<template>
  <v-container fluid class="py-6">
    <v-row>

      <v-col v-if="false" class="pa-12" md="12" lg="12" cols="12">
        <v-card class="card-shadow border-radius-xl h-100">
          <div class="px-4 pt-4">
            <h6 class="mb-0 text-h6 text-typo font-weight-bold">Post Newsletter</h6>
          </div>


          <div class="px-4 pt-4">

            <v-row class="mt-2">
              <v-col sm="12" cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                >Title</label
                >
                <v-text-field
                    hide-details
                    outlined
                    color="rgba(0,0,0,.6)"
                    light
                    placeholder="Review of Subscriptions"
                    class="
                          font-size-input
                          placeholder-lighter
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col sm="12" cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                >Description</label
                >
                <v-textarea
                    hide-details
                    outlined
                    color="rgba(0,0,0,.6)"
                    light
                    placeholder="This post speaks on the review of 2023 H1 fees"
                    class="
                          font-size-input
                          placeholder-lighters
                          text-light-input
                          border border-radius-md
                          mt-2
                        "
                >
                </v-textarea>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col sm="12" cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                >Type</label
                >
                <v-select
                    label="Select post type"
                    :items="['Notice', 'Newsletter']"
                ></v-select>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col sm="12" cols="12">
                <label class="text-xs text-typo font-weight-bolder ms-1"
                >Target Groups</label
                >
                <v-select
                    label="Select the target group"
                    :items="['Everyone', 'Paid', 'Pending', 'Subscribed']"
                ></v-select>
              </v-col>
            </v-row>
          </div>
          <div class="px-4 pb-4 d-flex align-center mt-8">
            <div class="w-40">
              <v-btn
                  color="#cb0c9f"
                  class="
                  align-center
                  font-weight-bolder
                  btn-default
                  bg-gradient-default
                  py-5
                  px-10
                "
                  small
              >
                Publish Newsletter
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-btn
            v-if="$store.state.is_administrator"
            elevation="0"
            :ripple="false"
            height="43"
            class="
            font-weight-bold
            text-uppercase
            btn-default
            bg-gradient-secondary
            py-2
            px-6
            me-2
            mb-sm-0 mb-2
          "
            color="#5e72e4"
            small
        >ADD NEW CIRCULAR</v-btn
        >
        <v-card class="card-shadow border-radius-xl">
          <div v-if="false">
            <v-card class="card-shadow border-radius-xl mt-6">
              <v-card-text class="px-0 py-0">
                <v-data-table
                    :headers="headers"
                    :items="returns"
                    :search="search"
                    class="table"
                    :page.sync="page"
                    hide-default-footer
                    @page-count="pageCount = $event"
                    :items-per-page="itemsPerPage"
                    mobile-breakpoint="0"
                >
                  <template v-slot:top>
                    <v-toolbar flat height="80">
                      <v-row>
                        <v-col cols="12" md="5">
                          <v-text-field
                              hide-details
                              class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                              dense
                              flat
                              filled
                              solo
                              height="43"
                              v-model="search"
                              placeholder="Search"
                          >
                            <template slot="prepend-inner">
                              <v-icon color="#adb5bd" size=".875rem"
                              >fas fa-search</v-icon
                              >
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.id="{ item }">
                    <div class="d-flex align-center">
                      <v-checkbox
                          :ripple="false"
                          v-model="item.checkbox"
                          color="#141727"
                      ></v-checkbox>
                      <span class="my-2 text-xs text-body font-weight-bold">{{
                          item.id
                        }}</span>
                    </div>
                  </template>

                  <template v-slot:item.date="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.date
              }}</span>
                  </template>

                  <template v-slot:item.status="{ item }">
                    <div class="d-flex align-center">
                      <v-btn
                          :ripple="false"
                          icon
                          outlined
                          rounded
                          width="25px"
                          height="25px"
                          class="me-2"
                          :class="
                  item.statusIcon == 'fas fa-check'
                    ? 'border-success'
                    : 'border-warning'
                "
                      >
                        <v-icon
                            size="8"
                            :class="
                    item.statusIcon == 'fas fa-check'
                      ? 'text-success'
                      : 'text-warning'
                  "
                        >
                          fas fa-check
                        </v-icon>
                      </v-btn>
                      <span class="text-body text-xs">{{ item.status }}</span>
                    </div>
                  </template>

                  <template v-slot:item.organisationName="{ item }">
                    <div class="d-flex align-center">
                      <v-avatar size="24" class="me-2 bg-gradient-default" >
                        <span class="text-white text-xs">{{ item.organisationName[0] }}</span>
                      </v-avatar>
                      <span class="text-body text-xs font-weight-bold">{{
                          item.organisationName
                        }}</span>
                    </div>
                  </template>

                  <template v-slot:item.product="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                item.product
              }}</span>
                  </template>

                  <template v-slot:item.amount="{ item }">
                    <span class="my-2 text-xs text-body font-weight-bold"> USD {{ ((item.amount / 100).toFixed(2)) }}</span>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-btn
                        @click="goTo(item)"
                        elevation="0"
                        small
                        :ripple="false"
                        height="21"
                        class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2
                  "
                        :class="
                    item.statusIcon == 'fas fa-check'
                      ? 'bg-gradient-success'
                      : 'bg-gradient-warning'
                  "
                    >{{item.statusIcon == 'fas fa-check'
                        ? 'View'
                        : 'View'}}</v-btn
                    >
                  </template>

                  <template v-slot:item.invoice="{ item }">
                    <v-btn
                        color="#fff"
                        class="text-dark font-weight-bolder px-1 shadow-0"
                        small
                        simple
                    >
                      <v-icon size="18" class="rotate-180"
                      >fas fa-file-pdf text-lg me-1</v-icon
                      >
                      Pdf
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions class="card-padding">
                <v-row>
                  <v-col cols="6" lg="3" class="d-flex align-center">
                    <span class="text-body me-3 text-sm">Items per page:</span>
                    <v-text-field
                        hide-details
                        type="number"
                        outlined
                        min="-1"
                        max="15"
                        background-color="rgba(255,255,255,.9)"
                        color="rgba(0,0,0,.6)"
                        light
                        :value="itemsPerPage"
                        @input="itemsPerPage = parseInt($event, 10)"
                        placeholder="Items per page"
                        class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="6" class="ml-auto d-flex justify-end">
                    <v-pagination
                        prev-icon="fa fa-angle-left"
                        next-icon="fa fa-angle-right"
                        class="pagination"
                        color="#cb0c9f"
                        v-model="page"
                        :length="pageCount"
                        circle
                    ></v-pagination>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </div>
          <div v-if="true">
            <v-card class="card-shadow border-radius-xl mt-6">
              <v-card-text class="px-0 py-0">
                <v-data-table
                    :headers="NewsHeaders"
                    :items="news"
                    :search="search"
                    class="table"
                    :page.sync="page"
                    hide-default-footer
                    @page-count="pageCount = $event"
                    :items-per-page="itemsPerPage"
                    mobile-breakpoint="0"
                >
                  <template v-slot:top>
                    <v-toolbar flat height="80">
                      <v-row>
                        <v-col cols="12" md="5">
                          <v-text-field
                              hide-details
                              class="
                      input-style
                      font-size-input
                      text-light-input
                      placeholder-light
                      input-icon
                    "
                              dense
                              flat
                              filled
                              solo
                              height="43"
                              v-model="search"
                              placeholder="Search"
                          >
                            <template slot="prepend-inner">
                              <v-icon color="#adb5bd" size=".875rem"
                              >fas fa-search</v-icon
                              >
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.dates="{ item }">
                    <div class="d-flex align-center">
                      <v-checkbox
                          :ripple="false"
                          v-model="item.checkbox"
                          color="#141727"
                      ></v-checkbox>
                      <span class="my-2 text-xs text-body font-weight-bold">{{
                          item.id
                        }}</span>
                    </div>
                  </template>

                  <template v-slot:item.date_created="{ item }">
            <span class="my-2 text-xs text-body font-weight-bold">{{
                new Date(item.date_created).toDateString()
              }} </span>
                  </template>

                  <template v-slot:item.amount="{ item }">
                    <span class="my-2 text-xs text-body font-weight-bold"> USD {{ ((item.amount / 100).toFixed(2)) }}</span>
                  </template>

                  <template v-slot:item.edit="{ item }">
                    <v-btn
                        @click="goToo()"
                        elevation="0"
                        small
                        :ripple="false"
                        height="21"
                        class="
                    border-radius-sm
                    font-weight-bolder
                    px-2
                    py-2
                    badge-font-size
                    ms-auto
                    text-white text-xxs
                    mb-2
                    bg-gradient-success
                  "


                    >EDIT</v-btn
                    >
                  </template>

                  <template v-slot:item.invoice="{ item }">
                    <v-btn
                        color="#fff"
                        class="text-dark font-weight-bolder px-1 shadow-0"
                        small
                        simple
                    >
                      <v-icon size="18" class="rotate-180"
                      >fas fa-file-pdf text-lg me-1</v-icon
                      >
                      Pdf
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions class="card-padding">
                <v-row>
                  <v-col cols="6" lg="3" class="d-flex align-center">
                    <span class="text-body me-3 text-sm">Items per page:</span>
                    <v-text-field
                        hide-details
                        type="number"
                        outlined
                        min="-1"
                        max="15"
                        background-color="rgba(255,255,255,.9)"
                        color="rgba(0,0,0,.6)"
                        light
                        :value="itemsPerPage"
                        @input="itemsPerPage = parseInt($event, 10)"
                        placeholder="Items per page"
                        class="
                font-size-input
                placeholder-lighter
                text-color-light
                input-alternative input-focused-alternative input-icon
              "
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="6" class="ml-auto d-flex justify-end">
                    <v-pagination
                        prev-icon="fa fa-angle-left"
                        next-icon="fa fa-angle-right"
                        class="pagination"
                        color="#cb0c9f"
                        v-model="page"
                        :length="pageCount"
                        circle
                    ></v-pagination>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ReportsTable from "./Widgets/ReportsTable.vue";
import Dropzone from "@/views/Client/Products/Widgets/Dropzone";
import {mapState} from "vuex";
import axios from "axios";

export default {
  name: "Dashboard",
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      fileSingle: [],
      NewsHeaders: [
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "title",
        },
        {
          text: "Description",
          align: "start",
          sortable: false,
          value: "description",
        },
        {
          text: "Target",
          align: "start",
          sortable: false,
          value: "Target",
        },
        {
          text: "Created",
          align: "start",
          sortable: false,
          value: "date_created",
        },
        {
          text: "Edit",
          align: "center",
          sortable: false,
          value: "edit",
          class: "text-secondary font-weight-bolder opacity-7 border-bottom",
        },
      ],
      news:[],
    };
  },
  components: {
    ReportsTable,
    Dropzone,
  },
  created () {
    if (this.$store.getters.is_administrator){
      this.getNews()
    }
  },
  computed: {
    ...mapState(['base_url']),
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    pages() {
      return this.pagination.rowsPerPage
          ? Math.ceil(this.items.length / this.pagination.rowsPerPage)
          : 0;
    },
  },
  methods: {
    async getNews() {
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/circular/all-circulars/', { headers: { Authorization: `Bearer ${JWTToken}` } } )
          .then(res => {
            if (res.status === 200) {
              this.news = res.data
            } else if (res.status === 202) {
              console.log('202')
            } else {
              console.log('error')
            }
          })
    },
    goTo(){
      this.$router.push("/return-payment");
    }
  },
};
</script>
